if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.querySelector('[data-errorclose]')?.addEventListener(
        'click',
        this.onClosePopupError.bind(this)
      );
    }

    onClosePopupError() {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (wrapper) wrapper.hidden = true;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.classList.contains('loading-process')) return;

      // ---- START LOADING STATE ----
      submitButton.classList.add('loading-process');
      submitButton.setAttribute('aria-disabled', 'true');
      this.form.classList.add('loading-process');
      submitButton
        .querySelector('.loading-overlay__spinner')
        ?.classList.remove('hidden');

      // ---- PREPARE FETCH ----
      const formData = new FormData(this.form);

      // Sections we want Shopify to re-render
      const sectionsToRender = [
        'header-cart',
        'cart-icon-bubble',
        'async-product-in-cart',
        'header-minicart-sticky',
        'cart-live-region-text'
      ];

      // Shopify expects a comma-separated string, not an array
      formData.append('sections', sectionsToRender.join(','));
      formData.append('sections_url', window.location.pathname);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      // Build add URL safely
      let addUrl = '';
      if (window.routes && window.routes.cart_add_url) {
        addUrl = window.routes.cart_add_url;
      } else {
        addUrl = `${window.Shopify.routes.root}cart/add.js`;
      }

      // Always enforce .js to avoid HTML responses
      if (!addUrl.endsWith('.js')) {
        addUrl = addUrl.replace(/\/$/, '') + '.js';
      }

      try {
        const response = await fetch(addUrl, config);
        const data = await response.json();

        // Shopify error from cart/add.js
        if (data.status && data.description) {
          this.handleErrorMessage(data.description);
          return;
        }

        // ✅ Update minicart + header sections if present
        if (data.sections) {
          const cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.renderContents === 'function') {
            cartItems.renderContents(data);
            cartItems.toggleEmptyClass?.(data);
          }

          // Save parsed state for other scripts that may rely on it
          try {
            localStorage.setItem('parsedState', JSON.stringify(data));
          } catch (e) {
            console.warn('Unable to persist parsedState:', e);
          }
        }

        // ✅ Fire global event so MiniCartPopup in cart.js can open
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

        // ✅ Success feedback on button text
        const span = submitButton.querySelector('span');
        const defaultText = span?.textContent || 'Add to Cart';
        if (span) {
          span.textContent =
            window.variantStrings?.added_to_cart || 'Added!';
          setTimeout(() => {
            span.textContent = defaultText;
          }, 1000);
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        this.handleErrorMessage('Something went wrong. Please try again.');
      } finally {
        // ---- END LOADING STATE ----
        submitButton.classList.remove('loading-process');
        submitButton.removeAttribute('aria-disabled');
        this.form.classList.remove('loading-process');
        submitButton
          .querySelector('.loading-overlay__spinner')
          ?.classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      const message = wrapper?.querySelector('.product-form__error-message');
      if (!wrapper) return;

      wrapper.hidden = !errorMessage;
      if (message && errorMessage) {
        message.textContent = errorMessage;
      }
    }

    setParsedState(response) {
      try {
        localStorage.setItem('parsedState', JSON.stringify(response));
      } catch (e) {
        console.warn('Unable to persist parsedState:', e);
      }
    }
  });
}

/* Safe helper – kept here in case other scripts import it */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  };
}

